<div class="item cn-up-down">
	<i class="icon audio-mes">
		<input-number-ico></input-number-ico>
		<span class="counter"><span>{{ node._id_ + 1 }}</span></span>
	</i>
	<div class="name">Ввод добавочного номера</div>
	<div *ngIf="node != null && node.next != null" schema-node [node]="node.next"></div>
</div>